import React, { useCallback, useEffect, useRef, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Grid, Hidden, Typography } from "@mui/material";
import AboutMe from "./AboutMe";
import { APPBARHEIGHT, SIDE_PADDING } from "../../../app/theme/muiTheme";
import Blogs from "./Blogs";
import SocialInitiatives from "./SocialInitiatives";
import Form from "./Form";
import Footer from "../../common/Footer";
import { useLocation } from "react-router-dom";
import { ABOUT, CONTACT } from "../../../app/api/routes";
import api from "../../../app/api";
const usestyles = makeStyles((theme) => ({
  root: {
    height: "91vh",
    // backgroundColor: theme.palette.primary.light,
    backgroundImage:
      "linear-gradient(90deg, rgba(239,242,247,1) 72%, rgba(231,238,241,1) 100%);",
    [theme.breakpoints.down("md")]: {
      height: "100vh",
    },
  },
  section1Root: {
    height: "100%",
    paddingLeft: SIDE_PADDING,
    // paddingRight: SIDE_PADDING,
    backgroundImage: "url(/images/homeSection1Background.svg)",
    backgroundSize: "105vw",

    [theme.breakpoints.down("md")]: {
      backgroundImage:
        "linear-gradient(90deg, rgba(239,242,247,1) 72%, rgba(231,238,241,1) 100%);",
      backgroundSize: "100vw",
      padding: 0,
      backgroundColor: "#B9CEED",
    },
    backgroundRepeat: "no-repeat",
    backgroundPosition: "bottom",
  },
  gitaversetxt: {
    fontSize: "2.3rem",
    [theme.breakpoints.down("md")]: {
      fontSize: 18,
    },
  },
  gitareftxt: {
    fontSize: "1.0rem",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  nametxt: {
    fontSize: 25,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  designationtxt: {
    fontSize: 18,
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  divmddown: {
    backgroundImage: "url(/images/homeSection1Backgroundsm.svg)",

    backgroundRepeat: "no-repeat",
    backgroundPosition: "bottom",
    backgroundSize: "100%",
    width: "91.6vw",
    height: "100vh",
    paddingLeft: "5%",
    paddingRight: "5%",
    paddingTop: "2%",
  },
}));

const Home = (props) => {
  const classes = usestyles();
  const location = useLocation().pathname;
  const formRef = useRef(null);
  const aboutRef = useRef(null);

  const [blogsList, setBlogsList] = useState([]);

  const fetchBlogs = useCallback(async () => {
    try {
      const { data } = await api.withoutAuth.get("/blogs?limit=3");
      setBlogsList(data.message || []);
    } catch (error) {
      console.log(error);
    } finally {
    }
  }, [setBlogsList]);

  useEffect(() => {
    fetchBlogs();
  }, [fetchBlogs]);

  useEffect(() => {
    if (location === CONTACT) {
      if (formRef.current) {
        blogsList &&
          window.scrollTo({
            top: formRef.current.offsetTop - APPBARHEIGHT,
            behavior: "smooth",
          });
      }
    } else if (location === ABOUT) {
      if (aboutRef.current) {
        window.scrollTo({
          top: aboutRef.current.offsetTop - APPBARHEIGHT,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location, blogsList]);

  return (
    <div className={classes.root}>
      <Grid container alignItems={"center"} className={classes.section1Root}>
        <Grid item md={7} xs={10}>
          <Hidden mdDown>
            <Typography className={classes.gitaversetxt}>
              “For upholders of justice there does not <br />
              exist a more appropriate endeavour than
              <br /> a battle for righteousness”
            </Typography>
            <br />
            <Typography className={classes.gitareftxt}>
              Bhagvad Gita, Chapter 2, Verse 31
            </Typography>
          </Hidden>
          <Hidden mdUp>
            <div className={classes.divmddown}>
              <Typography className={classes.gitaversetxt}>
                “For upholders of justice
                <br /> there does not exist a more <br />
                appropriate endeavour than <br />a battle for righteousness” ”
              </Typography>
              <br />
              <Typography className={classes.gitareftxt}>
                Bhagvad Gita, Chapter 2, Verse 31
              </Typography>

              <Hidden mdUp>
                <div
                  style={{
                    paddingTop: "65%",
                  }}
                >
                  <Typography className={classes.nametxt}>
                    Dibyanshu Pandey
                  </Typography>
                  <Typography className={classes.designationtxt}>
                    Advocate, Supreme Court of India
                  </Typography>
                </div>
              </Hidden>
            </div>
          </Hidden>
        </Grid>

        <Hidden mdDown>
          <Grid
            item
            xs={5}
            container
            justifyContent={"flex-end"}
            alignItems="end"
            height={"100%"}
          >
            <Grid
              container
              style={{
                paddingBottom: "7%",
                paddingRight: "15%",
              }}
              justifyContent={"flex-end"}
            >
              <div>
                <Typography variant="h6" className={classes.nametxt}>
                  Dibyanshu Pandey
                </Typography>
                <Typography variant="h6" className={classes.designationtxt}>
                  Advocate, Supreme Court of India
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Hidden>
      </Grid>

      <div ref={aboutRef}>
        <AboutMe />
      </div>
      <div>
        <Blogs blogsList={blogsList} />
      </div>
      <div>
        <SocialInitiatives />
      </div>
      <div ref={formRef}>
        <Form />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
